import React, { useEffect, useState } from "react";
import {
  Nav,
  NavBarContainer,
  NavLogo,
  MobileIcon,
  NavMenu,
  NavItem,
  NavLink,
  NavBtn,
  CvLink,
  CvDownloadButton,
} from "./StyledNavBar";
import { FaBars } from "react-icons/fa";
import { animateScroll as scroll } from "react-scroll";
import Avatar from "@mui/material/Avatar";
import myAvatar from "../images/MyAvatar.JPG";
import myResume from "./resume.pdf";
import { Tooltip, Zoom } from "@mui/material";

function NavBar({ toggle }) {
  const [scrollNav, setScrollNav] = useState(false);

  const handleScroll = () => {
    if (window.scrollY >= 80) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
  }, []);

  const toggleHome = () => {
    scroll.scrollToTop();
  };

  return (
    <Nav scrollNav={scrollNav}>
      <NavBarContainer>
        <Tooltip TransitionComponent={Zoom} title="Back To Top">
          <NavLogo to="/" onClick={toggleHome}>
            <Avatar src={myAvatar} sx={{ width: 50, height: 50 }}></Avatar>{" "}
          </NavLogo>
        </Tooltip>
        <MobileIcon onClick={toggle}>
          <FaBars />
        </MobileIcon>
        <NavMenu>
          <NavItem>
            <NavLink
              to="about"
              smooth={true}
              duration={500}
              spy={true}
              offset={-80}
            >
              About
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              to="skills"
              smooth={true}
              duration={500}
              spy={true}
              exact="true"
              offset={-80}
            >
              Skills
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              to="projects"
              smooth={true}
              duration={500}
              spy={true}
              exact="true"
              offset={-80}
            >
              My Projects
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              to="contact-me"
              smooth={true}
              duration={500}
              spy={true}
              exact="true"
            >
              Contact Me
            </NavLink>
          </NavItem>
        </NavMenu>
        <NavBtn>
          <CvLink href={myResume} download="AviMizrahiCV">
            <CvDownloadButton>Download Resume</CvDownloadButton>
          </CvLink>
        </NavBtn>
      </NavBarContainer>
    </Nav>
  );
}

export default NavBar;
